import type { HmiCanvasDocument } from "../schema/hmi-canvas.schema";

import { sourceFingerprint } from "./sourceFingerprint";

export type HmiBindingGraphNode = {
  bindingId: string;
  elementId: string;
  target: string;
  fingerprint: string;
};

export function buildBindingGraph(document: HmiCanvasDocument): HmiBindingGraphNode[] {
  return document.bindings.map((binding) => ({
    bindingId: binding.id,
    elementId: binding.elementId,
    target: binding.target,
    fingerprint: sourceFingerprint(binding.source),
  }));
}

